// extracted by mini-css-extract-plugin
export default {"UploadedPdf":"_UploadedPdf--_TXfG","HelperText":"_HelperText--l3oVw"};